import { render } from "./EventsGridComponent.vue?vue&type=template&id=179c1661"
import script from "./EventsGridComponent.vue?vue&type=script&lang=js"
export * from "./EventsGridComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__